/**
 * One date format on every Account Plans screen (UI tour, 2026-11-03): "Nov 3,
 * 2026". The screens mixed "11/3/2026", "Nov 3" and "2027-03-31".
 *
 * Calendar dates ("2027-03-31") are dates, not instants: read in local time, so
 * they never shift a day west of Greenwich. Anything that isn't a date reads as
 * null, never "Invalid Date".
 */
const CALENDAR = /^(\d{4})-(\d{2})-(\d{2})$/;

const toDate = (value: string): Date => {
  const m = CALENDAR.exec(value.trim());
  return m
    ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    : new Date(value);
};

export const formatPlanDate = (value?: string | null): string | null => {
  if (!value) return null;
  const d = toDate(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

/**
 * A value read from the plan ("2027-03-31", "Q3 FY27", "$2.4M"): an exact
 * calendar date is shown in the one format; anything else is shown as written.
 */
export const planValueText = (value?: string | null): string | null => {
  if (!value) return value ?? null;
  return CALENDAR.test(value.trim()) ? formatPlanDate(value) : value;
};
